"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerInputErrorMessage = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colorPickerTheme = require("../../colorPickerTheme");
const ColorPickerInputErrorMessage = (0, _styled.default)("p")`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _colorPickerTheme.colorPickerTheme.colorInput.errorColor(themeMode);
}};
    font-size: 13px;
    line-height: 18px;
    margin: 4px 0 0;
    display: flex;
    align-items: center;
`;
exports.ColorPickerInputErrorMessage = ColorPickerInputErrorMessage;
//# sourceMappingURL=ColorPickerInputErrorMessage.js.map